import { ActionType } from '../../constants/ActionTypes'

export default function seoSettingsReducer(state = {}, action = {}) {

    switch (action.type) {
        // case ActionType.GET_SEO_SETTINGS_BEGIN:
        //     return {
        //         ...state,
        //         isLoading: true
        //     }
        case ActionType.GET_SEO_SETTINGS_SUCCESS:
            return {
                ...state,
                [action.payload.lang]: {
                    ...state[action.payload.lang],
                    [action.payload.page]: {
                        data: action.payload.data,
                        lastUpdated: action.payload.lastUpdated
                    }
                }
            }
        case ActionType.SET_SEO_SETTINGS_PARAMS:
          
            return {
                ...state,
                [action.payload.lang]: {
                    ...state[action.payload.lang],
                    params: {
                        ...(state[action.payload.lang] ? state[action.payload.lang].params: {}),
                        ...action.payload.data,
                        lastUpdated: action.payload.lastUpdated
                    }
                }
            }
        // case ActionType.GET_SEO_SETTINGS_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload
        //     }
        default:
            return state;
    }

}

